import { useContext } from "react";
import { Button } from "../../../controls";
import { useTranslation } from "react-i18next";
import { AppContext } from "../../../App";
import { Model, UseForm } from "../../../hooks";
import { CartContext } from "../Pos";
import { PrintDiv, ToFormData } from "../../../hooks/Method";
import { action, controller, Server } from "../../../api/Server";

const InstantCheckout = ({ subTotal, cashMethod }) => {
  const { t } = useTranslation();
  const { settings, selStore, stores, authUser, setLoader } =
    useContext(AppContext);
  const { cartItems, tax, setReceptData, handleClearCart, setAlert, editSale } =
    useContext(CartContext);
  const { SellMdl } = Model();
  const { values } = UseForm(SellMdl);

  const handleSubmit = () => {
    // find selected store;
    var store = stores.find((j) => j.id === selStore);
    // define the sale values;
    const val = {
      id: editSale?.id || 0,
      storeId: selStore,
      sellItems: cartItems,
      taxPct: store ? store.tax : 0,
      tax: tax,
      totalPay: subTotal,
      received: subTotal,
      subtotal: subTotal.toFixed(settings.decimal),
      payments: [
        {
          payMethodId: cashMethod.id,
          amount: subTotal,
          methodTitle: cashMethod.label,
        },
      ],

      userId: authUser.id,
    };
    // **** Submit Action ****
    if (val.sellItems.length > 0) {
      setLoader(true);
      const onComplete = (res) => {
        if (res && res.status === 200) {
          setReceptData(res.result);
          setTimeout(() => {
            PrintDiv("printSellRecept");

            handleClearCart();
            setLoader(false);
          }, 1000);
        } else {
          setAlert({
            isOpen: true,
            type: "warning",
            title: t("warning"),
            subTitle: res.msg,
          });
          setLoader(false);
        }
      };

      // Submit data to the server.
      if (val.id > 0) {
        Server(controller.Sell + action.Put).put(
          ToFormData({
            ...values,
            ...val,
            lastUpdateDate: new Date().toISOString(),
          }),
          (res) => {
            localStorage.removeItem("sellId");
            onComplete(res);
          }
        );
      } else {
        Server(controller.Sell).post(
          ToFormData({
            ...values,
            ...val,
            sellDate: new Date().toISOString(),
          }),
          onComplete
        );
      }
    } else if (values.sellItems.length <= 0) {
      setAlert({
        isOpen: true,
        type: "warning",
        title: t("warning"),
        subTitle: t("noItemInCart"),
      });
    }
  };

  return (
    <Button
      color="error"
      sx={{
        boxShadow: "var(--shadow-xl) !important",
        fontSize: { lg: "20px", sm: "16px" },
        minWidth: "250px",
      }}
      onClick={handleSubmit}
    >
      <div className="d-flex j-between g-10 w-100pr">
        <span>{t("cash")}</span> |
        <span className="fw-6">
          {settings.curSymbol} {subTotal.toFixed(settings.decimal)}
        </span>
      </div>
    </Button>
  );
};

export default InstantCheckout;
